module.exports = __webpack_public_path__ + "static/eco_honey_comb-46e35af74f1f8c71445127ee41567c38.jpg";